import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb9b136c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main" }
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_header = _resolveComponent("base-header")!
  const _component_dashboard_table = _resolveComponent("dashboard-table")!
  const _component_subscription_selection = _resolveComponent("subscription-selection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createVNode(_component_base_header, {
        "title-left": "Willkommen",
        "title-right": "Dashboard",
        "title-main": "LEIs Ihres Profils"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_dashboard_table),
      _createVNode(_component_subscription_selection)
    ])
  ]))
}